import React from 'react';
import { Settings } from 'lucide-react';
import { useState } from 'react';
import type { ReportFilters } from '../../types/report.types';

const DATA_SOURCES = ['Transactions', 'Budgets', 'Goals', 'Bills', 'Investments', 'Categories'];
const CHART_TYPES = ['Bar Chart', 'Line Chart', 'Pie Chart', 'Area Chart', 'Data Table', 'Summary Cards'];

interface Props {
  onBuild: (filters: ReportFilters) => void;
}

export function CustomReportBuilderSection({ onBuild }: Props): React.ReactElement {
  const [expanded, setExpanded] = useState(false);
  const [dataSources, setDataSources] = useState<string[]>(['Transactions']);
  const [chartTypes, setChartTypes] = useState<string[]>(['Data Table']);

  const toggle = (list: string[], setList: (v: string[]) => void, item: string) => {
    setList(list.includes(item) ? list.filter((x) => x !== item) : [...list, item]);
  };

  return (
    <section className="rounded-xl border border-gray-200 bg-white p-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Custom Report Builder</h2>
          <p className="mt-1 text-sm text-gray-600">
            Create personalised reports with specific data points
          </p>
        </div>
        <button
          type="button"
          onClick={() => {
            setExpanded(true);
            onBuild({ dataSources, chartTypes });
          }}
          className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-blue-600 to-purple-600 px-4 py-2 text-sm font-medium text-white hover:from-blue-700 hover:to-purple-700"
        >
          <Settings className="h-4 w-4" aria-hidden />
          Build Custom Report
        </button>
      </div>

      {expanded && (
        <div className="mt-6 border-t border-gray-100 pt-6">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            <div>
              <h3 className="mb-2 font-medium text-gray-900">Data Sources</h3>
              <div className="space-y-2">
                {DATA_SOURCES.map((s) => (
                  <label key={s} className="flex items-center gap-2 text-sm text-gray-700">
                    <input
                      type="checkbox"
                      checked={dataSources.includes(s)}
                      onChange={() => toggle(dataSources, setDataSources, s)}
                      className="rounded text-blue-600"
                    />
                    {s}
                  </label>
                ))}
              </div>
            </div>
            <div>
              <h3 className="mb-2 font-medium text-gray-900">Chart Types</h3>
              <div className="space-y-2">
                {CHART_TYPES.map((c) => (
                  <label key={c} className="flex items-center gap-2 text-sm text-gray-700">
                    <input
                      type="checkbox"
                      checked={chartTypes.includes(c)}
                      onChange={() => toggle(chartTypes, setChartTypes, c)}
                      className="rounded text-blue-600"
                    />
                    {c}
                  </label>
                ))}
              </div>
            </div>
          </div>
          <p className="mt-4 text-xs text-gray-500">
            Inline preview is not available in v1.0 — use Build Custom Report to open the generation wizard.
          </p>
        </div>
      )}
    </section>
  );
}
